import React, { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { Flag } from "lucide-react";
import { api, apiError } from "@/lib/api";
import { toast } from "sonner";

export function ReportDialog({ targetType, targetId, label = "Segnala", triggerClassName = "" }) {
  const [open, setOpen] = useState(false);
  const [reason, setReason] = useState("");
  const [note, setNote] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async () => {
    if (!reason.trim()) { toast.error("Indica un motivo."); return; }
    setLoading(true);
    try {
      await api.post("/reports", { target_type: targetType, target_id: targetId, reason, note });
      toast.success("Segnalazione inviata. Grazie: la moderazione la esaminerà.");
      setOpen(false); setReason(""); setNote("");
    } catch (e) { toast.error(apiError(e)); }
    finally { setLoading(false); }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <button data-testid="report-trigger" className={`inline-flex items-center gap-1 text-xs text-[#94A3B8] hover:text-[#EF4444] ${triggerClassName}`}>
          <Flag className="h-3.5 w-3.5" /> {label}
        </button>
      </DialogTrigger>
      <DialogContent className="bg-[#141B2D] border-[#2A3655] text-[#F8FAFC]">
        <DialogHeader><DialogTitle className="font-display">Invia una segnalazione</DialogTitle></DialogHeader>
        <div className="space-y-3">
          <div>
            <Label className="text-[#CBD5E1]">Motivo</Label>
            <Textarea data-testid="report-reason" value={reason} onChange={(e) => setReason(e.target.value)}
              placeholder="Descrivi il problema" className="bg-[#0B1020] border-[#2A3655]" />
          </div>
          <div>
            <Label className="text-[#CBD5E1]">Note aggiuntive (facoltative)</Label>
            <Textarea data-testid="report-note" value={note} onChange={(e) => setNote(e.target.value)} className="bg-[#0B1020] border-[#2A3655]" />
          </div>
        </div>
        <DialogFooter>
          <Button data-testid="report-submit" onClick={submit} disabled={loading}
            className="bg-[#7C3AED] hover:bg-[#6D28D9]">{loading ? "Invio…" : "Invia segnalazione"}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
